import { IOfferingGroupQuery } from '../interfaces/group.query.interface';

// @dynamic
export class OfferingGroup {
    id: string;
    name: string;
    sort: number;
    isHidden: boolean; // Frontend Field

    constructor(courseOfferingQuery: IOfferingGroupQuery) {
        this.id = courseOfferingQuery.id.toString();
        this.name = courseOfferingQuery.name;
        this.sort = courseOfferingQuery.sort;
        this.isHidden = false;
    }
}
